module.exports = __webpack_public_path__ + "static/fonts/iconfont.bb24ed22.ttf";